// Do not import with ".." only, as it leads to cyclic dependencies!
import React from 'react';

import { NoConnectionNotification } from '../notifications/no-connection/NoConnectionNotification';

import { getDisplayName } from '@cp-shared-19/frontend-ui';

export type withNoConnectionHandlerProps = {
    hasError: boolean;
    component?: string;
};

export const withNoConnectionHandler = <TProps extends object>(
    WrappedComponent: React.ComponentType<TProps>,
): React.FC<TProps & withNoConnectionHandlerProps> => {
    const Wrapper: React.FC<TProps & withNoConnectionHandlerProps> = ({
        hasError,
        component,
        ...props
    }: withNoConnectionHandlerProps) =>
        hasError ? <NoConnectionNotification component={component} /> : <WrappedComponent {...(props as TProps)} />;

    Wrapper.displayName = `withNoConnectionHandler(${getDisplayName(WrappedComponent)})`;

    return Wrapper;
};
